import { render, staticRenderFns } from "./issue_card_inner.vue?vue&type=template&id=33bcca99&"
import script from "./issue_card_inner.vue?vue&type=script&lang=js&"
export * from "./issue_card_inner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports